import { Vector3 } from '@babylonjs/core';

export class BuildingModel {
    public name: string;
    public position: Vector3 | any;
    public isMain?: boolean;
    public depth: number;
    public floors?: number;
    public data: Vector3[];

    public constructor(data) {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                this[key] = data[key];
            }
        }
        this.position = new Vector3(...data.position);
        this.data = data.data.map(x => new Vector3(...x));
    }
}

export class RoadModel {
    public name: string;
    public width: number;
    public data: Vector3[] | any;

    public constructor(data: RoadModel) {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                this[key] = data[key];
            }
        }
        this.data = data.data.map(x => new Vector3(...x));
    }
}

export class MainDate {
    public lookAt: any;
    public scale: number;
    public buildingData: BuildingModel[];
    public ground: string;
    public roadData: RoadModel[];
    public mainBuilding: BuildingModel[];

    public constructor(data) {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                this[key] = data[key];
            }
        }
        this.buildingData = data.buildingData.map(x => new BuildingModel(x));
        this.roadData = data.roadData.map(x => new RoadModel(x));
        if (this.buildingData) {
            this.mainBuilding = this.buildingData.filter(x => x.isMain);
        }
    }

}
